<template>
    <div class="group">
        <div class="name" v-if="shouldDisplayName">{{ getNameForCurrentUser(optionGroup)
            }}</div>
        <div class="entries">
            <CartItemOption
                v-for="option in optionGroup.items"
                :key="option.id"
                :option="option"
                :multiplier="multiplier"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { ICartItemOptionGroup } from "@/data/model/Customer";
    import { useIdentityStore } from "@/data/stores/identity";
    import { getNameForCurrentUser } from "@/shared/helpers/ItemNameHelper";
    import { computed } from "vue";

    import CartItemOption from "@/app/components/cart/CartItemOption.vue";

    const identity = useIdentityStore();

    // define properties
    const props = defineProps<{
        optionGroup: ICartItemOptionGroup;
        multiplier: number;
    }>();

    // the group's "display name" setting is for the Mobile POS, end users always see the name
    const shouldDisplayName = computed(() => !identity.hasOperatorAccess || props.optionGroup.displayName);
</script>

<style lang="scss">
    @use "./../../../../assets/styles/scss/shared/_variables.scss";

    // kiosk: bigger group name. the cart view sets the size in px from its own deep
    // selector, so the override has to carry the same depth to win over it
    .kiosk-mode .app > .cart > .itemlist > .item .subs > .group > .name {
        font-size: 16px * variables.$kioskScale;
        line-height: 24px * variables.$kioskScale;
    }
</style>
